export const modalDelete = {
	messageProfile:
		"By confirming the action, you will permanently delete the tax profile {{ profile }}. Do you want to continue?",
	messageGroup:
		"By confirming the action, you will permanently delete the tax group {{ group }}. Do you want to continue?",
	profileDeletedSuccess: "Tax profile deleted successfully!",
	groupDeletedSuccess: "Tax group deleted successfully!",
};
